import React, { useState } from 'react';
export default function useModal(config) {
    const defaultVisible = (config === null || config === void 0 ? void 0 : config.defaultVisible) || false;
    const [visible, setIsVisible] = useState(defaultVisible);
    function show() {
        setIsVisible(true);
    }
    function close() {
        setIsVisible(false);
    }
    function toggle() {
        setIsVisible(!visible);
    }
    return { visible, show, close, toggle };
}
